import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HandBbox } from './HandBbox.js';
import { HandDecorate } from './HandDecorate.js';
export default function XRSceneComponents() {
    return (_jsxs(_Fragment, { children: [_jsx(HandBbox, {}), _jsx(HandDecorate, {})] }));
}
//# sourceMappingURL=XRSceneComponents.js.map